var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('dm-header',{attrs:{"id":"home"}}),_c('v-content',[_c('v-container',{staticClass:"app__container"},[_c('router-view',{staticClass:"mb-10"})],1)],1),_c('cookies'),_c('dm-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }